module.exports = __webpack_public_path__ + "img/ch9.fb278ab3.png";